var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZipfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 31.519 31.519",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.183,0L3.021,8.619v22.9h25.477V0H11.183z M21.132,24.505c-0.06,0.096-0.201,0.315-0.834,0.321 c-0.635-0.006-0.777-0.227-0.836-0.321c-0.535-0.866,0.027-3.132,0.791-5.104h0.088C21.105,21.373,21.666,23.639,21.132,24.505z  M10.464,3.625v3.818H6.847L10.464,3.625z M26.527,29.55H4.99V9.413h7.443V1.971h4.598v1.595h2.178v1.681h-2.178v1.857h2.178v1.857 h-2.178v1.857h2.178v1.761h-2.178v1.825H16.36v4.995h1.397c-0.715,2.07-1.276,4.707-0.28,6.327 c0.397,0.646,1.208,1.411,2.794,1.429v0.004c0.009,0,0.018-0.002,0.025-0.002c0.009,0,0.017,0.002,0.025,0.002v-0.004 c1.585-0.018,2.395-0.783,2.793-1.429c0.996-1.62,0.436-4.257-0.281-6.327h1.401v-4.995h-2.851v-1.825h2.179v-1.856h-2.177V8.961 h2.179V7.104h-2.179V5.327h2.179V3.47h-2.179V1.971h5.142L26.527,29.55L26.527,29.55z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipfile);
export default __webpack_public_path__ + "static/media/zipfile.f3e34a150916b8db6d6ad5a81cfa7d76.svg";
export { ForwardRef as ReactComponent };